import { Add, Cancel } from "@mui/icons-material";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import CustomButtonGrid from "components/uiComponents/CustomButtonGrid";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { FieldArray, Form, Formik } from "formik";
import { GrievenceRedressalModel } from "model/screensModels/GrievenceRedressalModel";
import { InvoiceManagementModel } from "model/screensModels/InvoiceManagementModel";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import { RequestModel } from "model/utilModels/RequestModel";
import React, { useEffect, useRef, useState } from "react";
import { GrievenceRedressalSchema } from "schemas/menu/grievenceRedressalSchema/GrievenceRedressalSchema";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { GrievenceRedressalService } from "services/menu/grievencereRedressalService/GrievenceRedressalService";
import { InvoiceManagementService } from "services/menu/invoiceManagementService/InvoiceManagementService";
import { UtilService } from "services/shared/UtilService";
import "./GrievenceRedressal.scss";
const GrievenceRedressal = ({ setFlag, updateRecord }) => {
  const [initialValues, setInitialValues] = useState(
    new GrievenceRedressalModel()
  );
  const [currencyList, setCurrencyList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);


  const formikRef = useRef(null);
  const invoiceStatus = [
    { "key": msgTypes.INVOICE_STATUS.PAID, "value": msgTypes.INVOICE_STATUS.PAID },
    { "key": msgTypes.INVOICE_STATUS.OUTSTANDING, "value": msgTypes.INVOICE_STATUS.OUTSTANDING },
  ]

  useEffect(() => {
    loadInitailData();
  }, []);

  const loadInitailData = async () => {
    await loadCompany();
    await getLoginmemberdetails();
    await getInvoiceList();
    getCurrencyList();
  };

  //load country
  const loadCompany = async () => {
    const res = await UtilService.getCompanyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setCompanyList(res.data);
      } else {
        setCompanyList([]);
      }
    }
  };

  //load invoice List
  const getInvoiceList = async () => {
    const requestData = new RequestModel();
    const companyDetails = JSON.parse(await LocalStorageService.getUserDetails());
    requestData.companyId = companyDetails.companyId;

    try {
      const res = await InvoiceManagementService.getInvoiceListByCompanyId(requestData);

      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        // Ensure res.data is an array before using map
        const invoiceData = Array.isArray(res.data) ? res.data : [];

        invoiceData.forEach(data => {
          data.invoiceId = String(data.invoiceId);
        });

        setInvoiceList(invoiceData);
      } else {
        setInvoiceList([]);
      }
    } catch (error) {
      console.error("Error fetching invoice list:", error);
      setInvoiceList([]); // Ensure state is updated even on error
    }
  };





  //load Currency
  const getCurrencyList = async () => {
    const res = await UtilService.getCurrencyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCurrencyList(res.data);
    }
  };

  const getLoginmemberdetails = async () => {
    const companyDetails = JSON.parse(
      await LocalStorageService.getUserDetails()
    );
    formikRef.current.setFieldValue("companyId", companyDetails.companyId);
    formikRef.current.setFieldValue(
      "address",
      companyDetails.addressLine1 +
      "," +
      companyDetails.city +
      "," +
      companyDetails.countryName
    );
  };

  const debtorCompanyAddress = async (value) => {
    formikRef.current.setFieldValue("debtorCompanyAddress", "");
    if (value != undefined) {
      const requestBody = new MembershipModel();
      requestBody.companyId = value.companyId;
      const res = await UtilService.getCompanyDetailsByCompanyId(requestBody);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        const data = res.data;
        var address = "";
        if (data?.addressLine1?.length > 0) {
          address = address + data.addressLine1 + ",";
        }
        if (data?.city?.length > 0) {
          address = address + data.city + ",";
        }
        address = address + data.countryName;
        formikRef.current.setFieldValue("debtorCompanyAddress", address);
      }
    }
  };

  const prepareRequestBody = async (values: GrievenceRedressalModel) => {
    const prepareData = new GrievenceRedressalModel();

    // Address and Company Information
    prepareData.companyId = values.companyId ? values.companyId : "";
    prepareData.address = values.address ? values.address : "";
    prepareData.debtorCompany = values.debtorCompany
      ? values.debtorCompany
      : "";
    prepareData.debtorCompanyAddress = values.debtorCompanyAddress
      ? values.debtorCompanyAddress
      : "";
    // Invoice Section
    prepareData.invoiceData = await Promise.all(
      values.invoiceData.map(async (invoice) => ({
        invoiceNumber: invoice.invoiceNumber ? invoice.invoiceNumber : "",
        currency: invoice.currency ? invoice.currency : "",
        invoiceAmount: invoice.invoiceAmount ? invoice.invoiceAmount : "",
        paidDate: invoice.paidDate ? invoice.paidDate : "",
        dueDate: invoice.dueDate ? invoice.dueDate : "",
        invoice: invoice.invoice
          ? await UtilService.getImagePath(invoice.invoice)
          : "",
        subject: invoice.subject ? invoice.subject : "",
        status: invoice.status ? invoice.status : "",
        // bankId: invoice.bankId ? invoice.bankId : ""
      }))
    );

    // Additional Sections
    prepareData.currencyData = values.currencyData.map((section) => ({
      currency: section.currency ? section.currency : "",
      unpaidAmount: section.unpaidAmount ? section.unpaidAmount : undefined,
    }));

    // Networks Section
    prepareData.networkData = values.networkData.map((network) => ({
      networkMembership: network.networkMembership
        ? network.networkMembership
        : "",
      contactPerson: network.contactPerson ? network.contactPerson : "",
      personEmail: network.personEmail ? network.personEmail : "",
    }));

    // Upload Sections

    prepareData.communication = await Promise.all(
      values.communication.map(async (data: any) =>
        data ? await UtilService.getImagePath(data.file) : ""
      )
    );

    prepareData.accountStatement = await Promise.all(
      values.accountStatement.map(async (data: any) =>
        data ? await UtilService.getImagePath(data.file) : ""
      )
    );

    prepareData.shippingDocument = await Promise.all(
      values.shippingDocument.map(async (data: any) =>
        data ? await UtilService.getImagePath(data.file) : ""
      )
    );

    prepareData.deliveryReceipt = await Promise.all(
      values.deliveryReceipt.map(async (data: any) =>
        data ? await UtilService.getImagePath(data.file) : ""
      )
    );

    prepareData.addentialRevelentDocoument = await Promise.all(
      values.addentialRevelentDocoument.map(async (data: any) =>
        data ? await UtilService.getImagePath(data.file) : ""
      )
    );

    // Other fields
    prepareData.lastDate = values.lastDate ? values.lastDate : null;
    prepareData.formContact = values.formContact ? values.formContact : "";
    prepareData.additionalNotes = values.additionalNotes
      ? values.additionalNotes
      : "";
    prepareData.formDeclare = values.formDeclare ? values.formDeclare : false;
    prepareData.termAndCondition = values.termAndCondition
      ? values.termAndCondition
      : false;
    prepareData.redressalId = values.redressalId ? values.redressalId : "";

    prepareData.claimForm = await UtilService.getImagePath(values.claimForm);

    return prepareData;
  };

  const onSubmit = async (values: GrievenceRedressalModel) => {
    const userId = localStorage.getItem('userId')
    const requestData = await prepareRequestBody(values);
    const finalPayload={
      ...requestData,
      userId:userId
    }
    console.log('anjali',requestData)
    const res = await GrievenceRedressalService.addGrievanceRedressal(
      finalPayload
    );
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setFlag(false);
      return true;
    } else {
      return false;
    }
  };


  const invoiceSelectionChange = async (values: InvoiceManagementModel, index: number, setFieldValue) => {
    setFieldValue(`invoiceData[${index}].invoiceAmount`, values.amount);
    setFieldValue(`invoiceData[${index}].paidDate`, values.paidDate);
    setFieldValue(`invoiceData[${index}].dueDate`, values.dueDate);
    setFieldValue(`invoiceData${index}`, values.uploadedInvoice);
    setFieldValue(`invoiceData[${index}].currency`, values.currency);
    setFieldValue(`invoiceData[${index}].status`, values.status);
    setFieldValue(`invoiceData[${index}].subject`, values.subject);
  }

  const formattedCurrencyList = currencyList.map(item => ({
    ...item,
    displayName: `${item.country} - ${item.currency}`,
  }));

  return (
    <>
      <div className="">
        <div className="outer-box-text card--">
          <div className="outer-box-text-one"></div>
          <p className="grievance-para">
            {" "}
            The grievance redressal system is effectively administered by 1WN - One World One Network, providing substantial benefits to all enrolled offices of member companies. We firmly believe in the importance of professionalism, and our extensive experience in this industry demonstrates that when companies within a network operate with professionalism and communicate clearly, the number of disputes that arise between agents can be dramatically reduced.
          </p>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-12 p-0">
              <Box className="outer-in">
                <Card className="form-container form-container-grav">
                  <Formik
                    // enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={GrievenceRedressalSchema}
                    onSubmit={async (values, { resetForm }) => {
                      const response = await onSubmit(values);
                      if (response) {
                        resetForm();
                        formikRef.current.setFieldValue("communication", [{}]);
                        getLoginmemberdetails();
                      }
                    }}
                    innerRef={formikRef}
                  >
                    {({ isValid, values, isSubmitting, dirty, errors, setFieldValue }) => (
                      <Form>
                        <div className="row">
                          <div className="col-lg-6 card--">
                            {/* Begin:: Conpany detail section */}
                            <div className="company-profile-sec border-0 h-100 one">
                              <div className="row p-3 mx-0">
                                <div className="col-12 status-sec">
                                  <h5 className="title-2 font-weight-bolder">
                                    Company Details
                                  </h5>
                                </div>
                              </div>
                              <div className="row p-4">
                                <div className="col-lg-6 col-md-6 position-relative">
                                  <FormikControl
                                    control="autocomplete"
                                    name="companyId"
                                    label="Company Name"
                                    // placeholder="Select Debtor Company"
                                    // requiredField
                                    options={companyList}
                                    keyfield="companyName"
                                    valuefield="companyId"
                                    requiredField
                                    disabled={true}
                                  />
                                </div>
                                <div className="col-lg-6 col-md-6 position-relative">
                                  <FormikControl
                                    control="textfield"
                                    name="address"
                                    label="Address"
                                    requiredField
                                    disabled={true}
                                  />
                                </div>
                                <div className="col-lg-6 col-md-6 position-relative">
                                  <FormikControl
                                    control="autocomplete"
                                    name="debtorCompany"
                                    label="Debtor Company"
                                    placeholder="Select Debtor Company"
                                    options={companyList}
                                    keyfield="companyName"
                                    valuefield="companyId"
                                    requiredField
                                    onChange={(value) =>
                                      debtorCompanyAddress(value)
                                    }
                                  />
                                </div>
                                <div className="col-lg-6 col-md-6 position-relative">
                                  <FormikControl
                                    control="textfield"
                                    name="debtorCompanyAddress"
                                    label="Debtor Company Address"
                                    placeholder=""
                                    requiredField
                                    disabled={true}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* End:: Conpany detail section */}
                          </div>
                          <div className="col-lg-6 card--">
                            {/* Begin::Invoice detail section */}
                            <div className="company-profile-sec border-0 h-100 position-relative ">


                              <FieldArray name="invoiceData">
                                {({ push, remove }) => (
                                  <>
                                    {values.invoiceData.map((invoice, index) => (
                                      <React.Fragment key={index}>
                                        {index === 0 && (
                                          <>
                                            <div className="row">
                                              <div className="redressal d-flex justify-content-between mb-2 p-4">
                                                <div className="row mx-0">
                                                  <div className="col-12">
                                                    <h5 className="title-2 font-weight-bolder mb-3">
                                                      Invoice Details
                                                    </h5>
                                                  </div>
                                                </div>
                                                <div className="redressal-btn">
                                                  <Button
                                                    sx={{ backgroundColor: "orange" }}
                                                    type="button"
                                                    className="btn-submit btn mt-0"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() =>
                                                      push({
                                                        invoiceNumber: "",
                                                        invoice: "",
                                                        currency: "",
                                                        invoiceAmount: "",
                                                        paidDate: "",
                                                        dueDate: "",
                                                        subject: "",
                                                        status: "",
                                                      })
                                                    }
                                                    startIcon={<Add />}
                                                  >
                                                    Add More
                                                  </Button>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}

                                        <div className="row m-0 invoice-data-section p-3 pt-0 position-relative">


                                          <div className="col-lg-12 col-md-12 position-relative">
                                            <FormikControl
                                              control='autocomplete'
                                              name={`invoiceData[${index}].invoiceNumber`}
                                              label="Invoice Number"
                                              placeholder="Select Invoice Number"
                                              onChange={(value) => { invoiceSelectionChange(value, index, setFieldValue) }}
                                              requiredField
                                              options={invoiceList}
                                              keyfield="invoiceId"
                                              valuefield="invoiceId"
                                            />
                                          </div>

                                          <div className="col-lg-6 col-md-6 position-relative">
                                            <FormikControl
                                              control='autocomplete'
                                              name={`invoiceData[${index}].status`}
                                              label="Invoice Status"
                                              placeholder="Choose invoice status"
                                              requiredField
                                              options={invoiceStatus}
                                              keyfield="key"
                                              valuefield="value"
                                            />
                                          </div>

                                          <div className="col-lg-6 col-md-6 position-relative">
                                            <FormikControl
                                              control="uploadImage"
                                              name={`invoiceData[${index}].invoice`}
                                              label="Upload Invoice"
                                              tooltip={[msgTypes.DOCUMENT_TYPE.PDF, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                              nameUrl={`invoiceData${index}`}
                                              requiredField
                                            />
                                          </div>
                                          <div className="col-lg-6 col-md-6 position-relative">
                                            <div className="col-lg-6 col-md-6 w-100 position-relative">
                                              <FormikControl
                                                control="autocomplete"
                                                name={`invoiceData[${index}].currency`}
                                                label="Select Currency"
                                                placeholder="Select currencey"
                                                requiredField
                                                options={formattedCurrencyList}
                                                keyfield="displayName"
                                                valuefield="code"
                                              />
                                            </div>
                                          </div>
                                          <div className="col-lg-6 col-md-6 position-relative">
                                            <FormikControl
                                              control="textfield"
                                              name={`invoiceData[${index}].invoiceAmount`}
                                              label="Invoice Amount"
                                              placeholder="Enter Invoice Amount"
                                              requiredField
                                            />
                                          </div>
                                          <div className="col-lg-6 col-md-6 position-relative">
                                            <FormikControl
                                              control="datepicker"
                                              name={`invoiceData[${index}].paidDate`}
                                              label="Paid Date"
                                              requiredField
                                            />
                                          </div>
                                          <div className="col-lg-6 col-md-6 position-relative">
                                            <FormikControl
                                              control="datepicker"
                                              name={`invoiceData[${index}].dueDate`}
                                              label="Due Date"
                                              requiredField
                                            />
                                          </div>

                                          <div className='row'>
                                            <div className="col-lg-12 col-md-12 position-relative">
                                              <FormikControl
                                                control='textfield'
                                                name={`invoiceData[${index}].subject`}
                                                label="Subject"
                                                placeholder="Enter subject"
                                                multiline={true}
                                                rows={4}
                                              />
                                            </div>
                                          </div>


                                          <div className="col-lg-12 col-md-12 position-relative justify-content-end d-flex">
                                            {index > 0 && (
                                              <FormikControl control='button' className="btn-cancel btn" color="warning" label="cancel" type="reset" onClick={() => remove(index)}
                                              />
                                            )}


                                          </div>




                                        </div>
                                      </React.Fragment>
                                    ))}
                                  </>
                                )}
                              </FieldArray>
                            </div>
                            {/* End::Invoice detail section */}

                          </div>
                        </div>




                        {/*Begin:: CurrencyData Sections - Hidden */}
                        <FieldArray name="currencyData">
                          {({ push, remove }) => (
                            <>
                              {values.currencyData.map((section, index) => (
                                <Grid container spacing={2} key={index}>
                                  <div className="company-profile-sec border-0 three container d-none">
                                    <div className="row p-4">
                                      <div className="col-lg-5 col-md-6 position-relative">
                                        <FormikControl
                                          control="select"
                                          name={`currencyData[${index}].currency`}
                                          label="Select Currency"
                                          requiredField
                                          options={[
                                            { key: "USD", value: "USD" },
                                            { key: "EURO", value: "EURO" },
                                            { key: "CHF", value: "CHF" },
                                            { key: "GBP", value: "GBP" },
                                          ]}
                                        />
                                      </div>
                                      <div className="col-lg-5 col-md-6 position-relative">
                                        <FormikControl
                                          control="textfield"
                                          name={`currencyData[${index}].unpaidAmount`}
                                          label="Total Amount Unpaid"
                                          placeholder="Enter Total Amount Unpaid"
                                        // requiredField
                                        />
                                      </div>
                                      {index === 0 && (
                                        <div className="col-lg-2 col-md-6">
                                          <Button
                                            type="button"
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                              push({
                                                currency: "",
                                                unpaidAmount: "",
                                              })
                                            }
                                            startIcon={<Add />}
                                            className="add-moref-button"
                                          >
                                            Add More
                                          </Button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Grid>

                              ))}
                            </>
                          )}
                        </FieldArray>
                        {/* End:: CurrencyData Sections - Hidden */}

                        {/* Begin:: messege sections */}
                        <div className="outer-box-text card--">
                          <div className="outer-box-text-one"></div>
                          <p className="grievance-para">
                            {" "}
                            A claimant is required to disclose to 1WN all other networks in which their company or any of its enrolled branches hold membership. The claimant must provide a complete list of all members associated with the company and its branches. Failure to provide this information, or if 1WN finds the provided details to be incorrect or incomplete, will result in the rejection of the claim.
                          </p>
                        </div>
                        {/* End:: messege sections */}

                        {/* NetworkData Section */}
                        <Grid container>
                          <div className="company-profile-sec border-0 container p-0 four card--">
                            <FieldArray name="networkData">
                              {({ push, remove }) => (
                                <>
                                  {values.networkData.map((network, index) => (
                                    <div key={index} className="invoice-data">
                                      <div className="row w-100 p-4">
                                        <div className="col-xl-3 col-md-6 position-relative">
                                          <FormikControl
                                            control="textfield"
                                            name={`networkData[${index}].networkMembership`}
                                            label="Other Network Membership"
                                            placeholder="Enter Other Network Membership"
                                          />
                                        </div>
                                        <div className="col-xl-3 col-md-6 position-relative">
                                          <FormikControl
                                            control="textfield"
                                            name={`networkData[${index}].contactPerson`}
                                            label="Contact Person"
                                            placeholder="Enter Contact Person"
                                          />
                                        </div>
                                        <div className="col-xl-3 col-md-6 position-relative">
                                          <FormikControl
                                            control="textfield"
                                            name={`networkData[${index}].personEmail`}
                                            label="Contact Person's Email"
                                            placeholder="Enter Contact Person's Email"
                                          />
                                        </div>

                                        <div className="col-xl-3 d-flex align-items-center">
                                          {index === 0 ? (
                                            <Button
                                              type="button"
                                              variant="contained"
                                              color="primary"
                                              onClick={() =>
                                                push({
                                                  networkMembership: "",
                                                  contactPerson: "",
                                                  personEmail: "",
                                                })
                                              }
                                              startIcon={<Add />}
                                              className="btn-submit btn"
                                            >
                                              Add Network
                                            </Button>
                                          ) : (
                                            <Button
                                              type="button"
                                              variant="contained"
                                              color="secondary"
                                              onClick={() => remove(index)}
                                              startIcon={<Cancel />}
                                              className="btn-cancel btn"
                                            >
                                              Remove Network
                                            </Button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </FieldArray>
                          </div>
                        </Grid>


                        {/* Upload Sections */}
                        <div className="row">
                          <div className="col-md-6 col-lg-4">
                            {/* Begin:: upload communication section */}
                            <Grid container>
                              <div className="company-profile-sec border-0 even p-3 container five card--">
                                <FieldArray name="communication">
                                  {({ push }) => (
                                    <>
                                      {values.communication.map((file, index) => (
                                        <Grid
                                          container
                                          item
                                          xs={12}
                                          spacing={2}
                                          key={index}
                                        >
                                          <div className="row w-100 p-1">
                                            <div className="col-12 position-relative">
                                              <FormikControl
                                                control="uploadImage"
                                                name={`communication[${index}].file`}
                                                label="Upload Communication"
                                                tooltip={[msgTypes.DOCUMENT_TYPE.PDF, msgTypes.DOCUMENT_TYPE.TXT,
                                                msgTypes.DOCUMENT_TYPE.XLSX, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                                nameUrl={`communication${index}`}
                                              />
                                            </div>
                                            {index === 0 &&
                                              JSON.stringify(
                                                values.communication[0]
                                              ) !== "{}" && (
                                                <div className="col-2 d-flex align-items-center">
                                                  <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() =>
                                                      push({ file: null })
                                                    }
                                                    fullWidth
                                                    className="add-mores-button added-plus"
                                                  >
                                                    +
                                                  </Button>
                                                </div>
                                              )}
                                          </div>


                                        </Grid>
                                      ))}
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            </Grid>
                          </div>
                          <div className="col-md-6 col-lg-4">
                            <Grid container>
                              <div className="company-profile-sec border-0 p-3 container six work">
                                <FieldArray name="accountStatement">
                                  {({ push }) => (
                                    <>
                                      {values.accountStatement.map(
                                        (file, index) => (
                                          <Grid
                                            container
                                            item
                                            xs={12}
                                            spacing={2}
                                            key={index}
                                          >
                                            <div className="row p-1 w-100 ">
                                              <div className="col-12 position-relative">
                                                <FormikControl
                                                  control="uploadImage"
                                                  name={`accountStatement[${index}].file`}
                                                  label="Upload Statement of Account"
                                                  tooltip={[msgTypes.DOCUMENT_TYPE.PDF,
                                                  msgTypes.DOCUMENT_TYPE.XLSX, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                                  nameUrl={`accountStatement${index}`}
                                                //requiredField
                                                />
                                              </div>
                                              {index === 0 &&
                                                JSON.stringify(
                                                  values.accountStatement[0]
                                                ) !== "{}" && (
                                                  <div className="col-2 d-flex align-items-center">
                                                    <Button
                                                      type="button"
                                                      variant="contained"
                                                      color="primary"
                                                      className="add-mores-button added-plus"
                                                      onClick={() =>
                                                        push({ file: null })
                                                      }
                                                      fullWidth
                                                    >
                                                      +
                                                    </Button>
                                                  </div>
                                                )}
                                            </div>


                                          </Grid>
                                        )
                                      )}
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            </Grid>
                            {/* End:: Upload Account statement */}
                          </div>
                          <div className="col-md-6 col-lg-4">
                            {/* Begin:: upload shippingDocument         */}
                            <Grid container>
                              <div className="company-profile-sec border-0 p-3 container seven work">
                                <FieldArray name="shippingDocument">
                                  {({ push }) => (
                                    <>
                                      {values.shippingDocument.map(
                                        (file, index) => (
                                          <Grid
                                            container
                                            item
                                            xs={12}
                                            spacing={2}
                                            key={index}
                                          >
                                            <div className="row p-1 w-100">
                                              <div className="col-12 position-relative">
                                                <FormikControl
                                                  control="uploadImage"
                                                  name={`shippingDocument[${index}].file`}
                                                  label="Upload Shipping Documents"
                                                  tooltip={[msgTypes.DOCUMENT_TYPE.PDF, msgTypes.DOCUMENT_TYPE.CSV,
                                                  msgTypes.DOCUMENT_TYPE.XLSX, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                                  nameUrl={`shippingDocument${index}`}
                                                />
                                              </div>
                                              {index === 0 &&
                                                JSON.stringify(
                                                  values.shippingDocument[0]
                                                ) !== "{}" && (
                                                  <div className="col-2 d-flex align-items-center">
                                                    <Button
                                                      type="button"
                                                      variant="contained"
                                                      color="primary"
                                                      className="add-mores-button added-plus"
                                                      onClick={() =>
                                                        push({ file: null })
                                                      }
                                                      fullWidth
                                                    >
                                                      +
                                                    </Button>
                                                  </div>
                                                )}
                                            </div>


                                          </Grid>
                                        )
                                      )}
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            </Grid>
                            {/* End:: upload shippingDocument         */}
                          </div>
                          <div className="col-md-6 col-lg-4 card--">
                            {/* Begin:: upload deliveryReceipt         */}
                            <Grid container>
                              <div className="company-profile-sec border-0 p-3 container eight work mb-0">
                                <FieldArray name="deliveryReceipt">
                                  {({ push }) => (
                                    <>
                                      {values.deliveryReceipt.map((file, index) => (
                                        <Grid
                                          container
                                          item
                                          xs={12}
                                          spacing={2}
                                          key={index}
                                        >
                                          <div className="row p-1 w-100">
                                            <div className="col-12 position-relative">
                                              <FormikControl
                                                control="uploadImage"
                                                name={`deliveryReceipt[${index}].file`}
                                                label="Upload Delivery Receipt"
                                                tooltip={[msgTypes.DOCUMENT_TYPE.PDF, msgTypes.DOCUMENT_TYPE.CSV,
                                                msgTypes.DOCUMENT_TYPE.XLSX, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                                nameUrl={`deliveryReceipt${index}`}
                                              />
                                            </div>
                                            {index === 0 &&
                                              JSON.stringify(
                                                values.deliveryReceipt[0]
                                              ) !== "{}" && (
                                                <div className="col-2 d-flex align-items-center">
                                                  <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="primary"
                                                    className="add-mores-button added-plus"
                                                    onClick={() =>
                                                      push({ file: null })
                                                    }
                                                    fullWidth
                                                  >
                                                    +
                                                  </Button>
                                                </div>
                                              )}
                                          </div>


                                        </Grid>
                                      ))}
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            </Grid>
                          </div>
                          <div className="col-md-6 col-lg-4">
                            <Grid container>
                              <div className="company-profile-sec border-0 p-3 container nine work">
                                <FieldArray name="addentialRevelentDocoument">
                                  {({ push }) => (
                                    <>
                                      {values.addentialRevelentDocoument.map(
                                        (file, index) => (
                                          <Grid
                                            container
                                            item
                                            xs={12}
                                            spacing={2}
                                            key={index}
                                          >
                                            <div className="row p-1 w-100">
                                              <div className="col-12 position-relative">
                                                <FormikControl
                                                  control="uploadImage"
                                                  name={`addentialRevelentDocoument[${index}].file`}
                                                  label="Upload Additional Documentation"
                                                  tooltip={[msgTypes.DOCUMENT_TYPE.PDF, msgTypes.DOCUMENT_TYPE.CSV,
                                                  msgTypes.DOCUMENT_TYPE.XLSX, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                                  nameUrl={`addentialRevelentDocoument${index}`}
                                                />
                                              </div>
                                              {index === 0 &&
                                                JSON.stringify(
                                                  values
                                                    .addentialRevelentDocoument[0]
                                                ) !== "{}" && (
                                                  <div className="col-2 d-flex align-items-center">
                                                    <Button
                                                      type="button"
                                                      variant="contained"
                                                      color="primary"
                                                      className="add-mores-button added-plus"
                                                      onClick={() =>
                                                        push({ file: null })
                                                      }
                                                      fullWidth
                                                    >
                                                      +
                                                    </Button>
                                                  </div>
                                                )}
                                            </div>


                                          </Grid>
                                        )
                                      )}
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            </Grid>
                            {/* End:: upload addentialRevelentDocoument   */}
                          </div>
                        </div>

                        <div className="company-profile-sec border-0 container eleven ">
                          <div className="row justify-content-center">
                            <div className="col-lg-12">
                              <div className="row p-4">
                                <div className="col-lg-6 col-md-6">
                                  <div className="row">
                                    <div className="col-lg-8 position-relative">
                                      <FormikControl
                                        control="uploadImage"
                                        name="claimForm"
                                        label="Protection Claim Form"
                                        tooltip={[msgTypes.DOCUMENT_TYPE.PDF, msgTypes.DOCUMENT_TYPE.TXT, msgTypes.FILE_SIZE_ALLOW_3MB]}
                                        nameUrl="claimFormFile"
                                      //  requiredField
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="row">
                                    <div className="col-lg-8 position-relative">
                                      <FormikControl
                                        control="datepicker"
                                        name="lastDate"
                                        label="Last Contact Date"
                                      //  requiredField
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="row">
                                    <div className="col-lg-8 position-relative">
                                      <FormikControl
                                        control="textfield"
                                        name="formContact"
                                        label="Last Contact Details"
                                        placeholder="Email,phone"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 textarea-sec   position-relative">
                                  <div className="row">
                                    <div className="col-lg-8 position-relative">
                                      <FormikControl
                                        control="textfield"
                                        label="Additional Notes"
                                        type="text"
                                        //requiredField
                                        multiline
                                        rows={6}
                                        fullWidth
                                        name="additionalNotes"
                                        placeholder="Additional Notes"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12 col-md-6">
                                  <div className="row ">
                                    <div className="col-lg-12">
                                      <label>
                                        Has the invoice been uploaded to the 1wn
                                        Financial protection System?
                                      </label>
                                    </div>
                                    <div className="col-lg-8 position-relative">
                                      <FormikControl
                                        control="radiogroup"
                                        name="protectionSystem"
                                        options={[
                                          { key: "Yes", value: "Yes" },
                                          { key: "No", value: "No" },
                                        ]}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-12">
                                  <Typography className="typo-1">
                                    All claims for 1WN - One World One Network are required to be submitted within 60 days following the due date of the corresponding invoice(s).

                                  </Typography>
                                  <Typography className="typo-1">
                                    Please note that claims submitted prior to the invoice(s) due date will not be accepted.
                                  </Typography>

                                  <Typography className="typo-1">
                                    1WN - One World One Network firmly reserves the right to terminate the membership of any party against whom a claim is paid and will promptly notify all other members of this action.
                                  </Typography>
                                </div>
                                <div className="col-12">
                                  <FormikControl
                                    control="checkbox"
                                    name="formDeclare"
                                    label="I certify that the information provided is accurate and true to the best of my knowledge."
                                  />
                                </div>
                                <div className="col-12">
                                  <FormikControl
                                    control="checkbox"
                                    name="termAndCondition"
                                    label="I agree to the terms of the 1WN Financial Protection Plan."
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <CustomButtonGrid
                            className="bg-white pb-4 grav-button"
                            item={
                              <>
                                <FormikControl
                                  control="button"
                                  color="primary"
                                  label="Submit"
                                  type="submit"
                                  className="btn btn-submit mr-4 mb-4"
                                  disabled={!dirty || !isValid}
                                />
                                <FormikControl control='button' className="btn btn-cancel grav-back" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                              </>
                            }
                          />
                        </div>



                      </Form>
                    )}
                  </Formik>
                </Card>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GrievenceRedressal;
